import { AfterViewInit, Component, EventEmitter, OnDestroy, OnInit, Output, Renderer2, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DxDataGridComponent } from 'devextreme-angular';
import DataSource from 'devextreme/data/data_source';
import { BehaviorSubject, of, Subject } from 'rxjs';
import { debounceTime, take, takeUntil } from 'rxjs/operators';
import { FusionAuthService } from '../../../../../shared/services/fusion-auth';
import { DOMService, ScreenService } from '../../../../../shared/services/general';
import { ClientService } from '../../../../shared/services';
import { TestService } from '../../../../shared/services/test.service';

@Component({
    selector: 'app-standing-order-search',
    templateUrl: './standing-order-search.component.html',
    styleUrls: ['./standing-order-search.component.scss'],
})
export class StandingOrderSearchComponent implements OnInit, OnDestroy, AfterViewInit {
    @ViewChild('dropDownGrid', { static: false }) public dropDownGrid?: DxDataGridComponent;
    @Output() public formSubmitted = new EventEmitter();
    public standingOrderSearchForm: FormGroup;
    // @ts-ignore
  public pickerDataSource: BehaviorSubject<DataSource> = new BehaviorSubject<DataSource>(null);
    // @ts-ignore
  public unitDataSource: BehaviorSubject<DataSource> = new BehaviorSubject<DataSource>(null);
    public pickerSelectedTestsKey: number[] = [];
    public role: string;
    public isPhone: boolean = false;
    public isTablet: boolean  = false;
    public isPhoneLandscape: boolean = false;
    public isPhoneOrTablet: boolean = false;
    private onDestroy$: Subject<void> = new Subject<void>();

    constructor(
        private fb: FormBuilder,
        private domService: DOMService,
        private clientService: ClientService,
        private testService: TestService,
        private fusionAuthService: FusionAuthService,
        private screen: ScreenService,
        private renderer: Renderer2,
    ) {
        this.role = fusionAuthService.Profile.registrations[0].roles[0];
        this.standingOrderSearchForm = this.fb.group({
            patient: [null],
            testIds: [null],
            client: [null],
            unit: [null],
        });
    }

    public ngAfterViewInit(): void {
        of(null)
            .pipe(
                take(1),
                debounceTime(2000),
            )
            .subscribe(() => {
                this.standingOrderSearchForm.get('client')?.valueChanges
                    .pipe(takeUntil(this.onDestroy$))
                    .subscribe(client => {
                        if (client) {
                            this.unitDataSource.next(new DataSource({
                                store: this.clientService.clientUnitsCustomStore(client.id, this.unitDataSource),
                            }));
                        } else {
                            // @ts-ignore
                          this.unitDataSource.next(null);
                        }
                    });
            });
    }

    public ngOnInit() {
        this.isPhone = this.screen.sizes['screen-x-small'];
        this.isPhoneLandscape = this.screen.sizes['screen-small'];
        this.isPhoneOrTablet = this.screen.sizes['screen-x-small'] || this.screen.sizes['screen-small'] || this.screen.sizes['screen-tablet'];
        this.isTablet = this.screen.sizes['screen-small'] || this.screen.sizes['screen-tablet'];
        this.screen.changed.pipe(takeUntil(this.onDestroy$)).subscribe(() => {
            this.isPhone = this.screen.sizes['screen-x-small'];
            this.isTablet = this.screen.sizes['screen-small'] || this.screen.sizes['screen-tablet'];
            this.isPhoneOrTablet = this.screen.sizes['screen-x-small'] || this.screen.sizes['screen-small'] || this.screen.sizes['screen-tablet'];
            this.resizePickerDropDown();
        });

        this.waitByUser();
    }

    private waitByUser() {
        const user = this.fusionAuthService.Profile;
        if (user) {
            const role = user.registrations[0].roles[0];
            const clientsIds = role === 'Client Admin' || role === 'Client Basic' ? user.data.clients : null;
          this.pickerDataSource.next(new DataSource({
            // @ts-ignore
                store: this.testService.customStore(this.pickerDataSource, null, clientsIds === null, clientsIds)
            }));
        } else {
            of(null)
                .pipe(
                    debounceTime(1000),
                    take(1)
                )
                .subscribe(() => this.waitByUser());
        }
    }

    public searchStandingOrders(): void {
        this.submit();
    }

    public clear() {
        this.standingOrderSearchForm.reset();
        this.pickerSelectedTestsKey = [];
        this.submit();
    }

    public resizePickerDropDown() {
        const element = this.domService.getElementsByClassname('dx-overlay-wrapper dx-dropdowneditor-overlay dx-popup-wrapper').item(0) as HTMLElement;
        if (element) {
            if (this.isPhoneOrTablet) {
                this.renderer.setStyle(element, 'width', '300px');
                this.renderer.setStyle(element.firstChild, 'width', '300px');
            } else {
                this.renderer.setStyle(element, 'width', '580px');
                this.renderer.setStyle(element.firstChild, 'width', '580px');
            }
            this.renderer.setStyle(element, 'height', '50vh');
            this.renderer.setStyle(element.firstChild, 'height', '50vh');
            this.renderer.setStyle(element.firstChild?.firstChild, 'height', '50vh');
        }

        if (this.dropDownGrid !== undefined) {
            this.dropDownGrid.instance.clearFilter();
        }
    }

    private submit() {
        this.standingOrderSearchForm.get('testIds')?.setValue(this.pickerSelectedTestsKey);
        this.formSubmitted.emit(this.standingOrderSearchForm.value);
    }

    public ngOnDestroy(): void {
        this.onDestroy$.next();
        this.onDestroy$.complete();
    }
}
